import { OpenAPI } from "generated-api"
import { getBaseUrl } from "./repository"

// https://blog.logrocket.com/generating-integrating-openapi-services-react/
// https://www.npmjs.com/package/openapi-typescript-codegen

export const initializeAPIBaseUrl = (): void => {
  OpenAPI.BASE = getBaseUrl()
}

export const initializeAPICredentials = (token: string): void => {
  OpenAPI.HEADERS = {
    ...OpenAPI.HEADERS,
    "adstanding-session-id": String(token)
  }
}

export const resetAPICredentials = () => {
  if (!OpenAPI.HEADERS) {
    return
  }
  delete (OpenAPI.HEADERS as any)["adstanding-session-id"]
  delete (OpenAPI.HEADERS as any).user_id
}
